const {getSupplierExport} = require('../tools/index')
const generateExcelSheet = require('./excel')

// returns an excel file thing and is called by the UI
function exportOrderNotes (state,
  suppliers,
  orders,
  locationsById,
  productsById,
  routesById,
  supplierId,
  locationId,
  currentPrices,
  { showDiscounts = false } = {}) {
  const result = getSupplierExport(suppliers,
    orders,
    locationsById,
    productsById,
    routesById,
    currentPrices,
    { applyDiscount: showDiscounts })

  return generateExcelSheet(result, supplierId, locationId)
}

module.exports = {exportOrderNotes}
